import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusRevision.tsx
const IconApplicationStatusRevision = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M16.667 1.667c.46 0 .833.373.833.833v3.13l-7.499 7.5-.005 3.532 3.538.006 3.966-3.966V17.5c0 .46-.373.833-.833.833H3.333A.833.833 0 0 1 2.5 17.5v-15c0-.46.373-.833.833-.833zm1.481 5.673 1.179 1.178L12.845 15l-1.18-.002.002-1.177zM10 10H5.833v1.666H10zm2.5-3.333H5.833v1.666H12.5z"
	})]
});
var IconApplicationStatusRevision_default = forwardRef(IconApplicationStatusRevision);
//#endregion
export { IconApplicationStatusRevision_default as default };
